var map = {
	"./Image.png": 6569,
	"./Rectangle(2).svg": 584,
	"./Rectangle(3).svg": 3009,
	"./Rectangle(4).svg": 7463,
	"./Rectangle(5).svg": 7927,
	"./Rectangle.svg": 8560,
	"./Vector.svg": 294,
	"./bg-teal.svg": 4750,
	"./book1.jpg": 1394,
	"./book2.jpg": 8063,
	"./book3.jpg": 3314,
	"./bookreader.jpg": 6919,
	"./completed.svg": 8861,
	"./cube.svg": 8191,
	"./facebook.png": 1869,
	"./google.png": 6176,
	"./logo.svg": 5934,
	"./love.png": 3287,
	"./object-4.png.png": 4777,
	"./rve.svg": 1870,
	"./star.svg.svg": 4558,
	"./uncompleted.svg": 3295,
	"./undraw_books_re_8gea.svg": 7405,
	"./undraw_pic_profile_re_7g2h(1).svg": 6413,
	"./undraw_reading_re_29f8.svg": 8879
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3581;